/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Allfunds1Inputs */

const en_common_allfunds1 = /** @type {(inputs: Common_Allfunds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Funds`)
};

/**
* | output |
* | --- |
* | "All Funds" |
*
* @param {Common_Allfunds1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_allfunds1 = /** @type {((inputs?: Common_Allfunds1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Allfunds1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_allfunds1(inputs)
});
export { common_allfunds1 as "common_allFunds" }